import modelBaseV2 from "../model-base-v2.model"

const getApplicationList = (params) => {
  const qs = modelBaseV2.toQueryString(params)
  return modelBaseV2.get('/api/posmGoodsIssueApplication/list?' + qs)
}
const getDetailApplication = (movementControlId) => {
  return modelBaseV2.get('/api/posmGoodsIssueApplication/getDetail/:movementControlId', { params: { movementControlId } })
}
const saveApplication = (body) => {
  return modelBaseV2.post('/api/posmGoodsIssueApplication/save', { body })
}
const actionApplication = (body) => {
  return modelBaseV2.post('/api/posmGoodsIssueApplication/action', { body })
}
const getGoodsChannelTemplate = (mainCate) => {
  return modelBaseV2.getDownload(`/api/posmGoodsIssueApplication/getGoodsChannelTemplate/${mainCate.code}`, {}, `GoodsChannelTemplate_${mainCate.name}`)
}
const channelGoodsQtyCheck = (body) => {
  return modelBaseV2.post('/api/posmGoodsIssueApplication/channelGoodsQtyCheck', { body })
}

const downloadGoodsApplicationList = (body) => {
  body.PageSize = -1;
  body.PageIndex = 1;
  const paramsMapping = {
    OrderBy: '2',
    PageIndex: '3',
    PageSize: '4',
    SortBy: '24',
    DateFrom: '138',
    DateTo: '139',
    ChannelCode: '145',
    GoodsId: '148',
    ApprovalStatusCode: '146',
    WarehouseId: '143',
    StorageId: '144',
  }
  const params = Object.entries(paramsMapping).map(([key, value]) => {
    let arg = body[key];
    return {
      code: value,
      value: arg
        ? Array.isArray(arg)
          ? arg.join('^')
          : arg.toString()
        : ""
    }
  })

  const exportConfig = {
    excelSheetNames: [
      "Application List"
    ],
    storedProcedureCode: "71",
    params
  }
  return modelBaseV2.postDownload('/api/survey/export/tr/file', { body: exportConfig }, `GoodsApplicationList_${body.DateFrom}-${body.DateTo}.xlsx`);
}

export { getApplicationList, getDetailApplication, saveApplication, getGoodsChannelTemplate, channelGoodsQtyCheck, actionApplication, downloadGoodsApplicationList } 